import _ from 'lodash';
import {fromJS, Map} from 'immutable';
import * as Cookies from 'js-cookie';

import * as actions from './actions';
import {components} from './Application';


const token = Cookies.getJSON('mhelli-token');
export default function reducer(
    state = fromJS({
        token: token || undefined,
        pageType: actions.PAGE_NORMAL,
        user: {hasPerm: () => false, is: () => false},
        application: 'main',
        defaultApplication: 'main',
        pending: 0,
        components: {},
    }),
    action,
) {
    if (state.get('token') && state.get('token').size === 0) {
        state = state.delete('token');
    }
    switch (action.type) {
    case actions.SET_MODE:
        state = state.set('mode', action.mode);
        break;

    case actions.SET_PAGE_TYPE:
        state = state.set('pageType', action.payload);
        break;

    case actions.INCREMENT_PENDING:
        state = state.set('pending', state.get('pending') + 1);
        break;

    case actions.DECREMENT_PENDING:
        state = state.set('pending', state.get('pending') - 1);
        break;

    case actions.SET_USER:
        state = state.set(
            'user',
            fromJS({
                ...action.payload,
                hasPerm: permission => _.includes(action.payload.type, 'admin') || _.some(
                    action.payload.permissions,
                    p => p.app_label.toLowerCase() + '.' + p.codename.toLowerCase() === permission.toLowerCase(),
                ),
                is: type => _.includes(action.payload.type, type),
            }),
        );
        break;

    case actions.FETCH_INFORMATION:
        state = state.set('fetchInformationCounter', state.get('fetchInformationCounter', 0) + 1);
        break;

    case actions.SET_APPLICATION:
        state = state.set('application', action.payload);
        break;

    case actions.SET_DEFAULT_APPLICATION:
        state = state.set('defaultApplication', action.payload);
        break;

    case actions.LOGGED_IN:
        state = state.set('token', fromJS(action.token));
        break;

    case actions.LOGGED_OUT:
        state = state.delete('token');
        state = state.set('user', new Map({hasPerm: () => false, is: () => false}));
        break;

    case actions.LOGIN_FAILED:
        state = state.set('loginError', action.error);
        break;

    case actions.SET_UNREAD_MESSAGES:
        state = state.set('unreadMessages', action.payload);

    case actions.SET_COMPONENTS_INITIAL_STATE:
        state = state.setIn(
            ['components', action.component, action.instanceId],
            fromJS(action.state),
        );
        break;
    }

    _.forEach(components, (component, name) => {
        if (!state.get('components').get(name))
            return;
        state.get('components').get(name).forEach(
            (instanceState, instanceId) => {
                state = state.setIn(
                    ['components', name, instanceId],
                    component.reducer(
                        state.get('components').get(name).get(instanceId),
                        action,
                    ),
                );
            },
        );
    });
    return state;
}
